export default __webpack_public_path__ + "static/media/subtract.76463c5c.svg";